import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "@/stores/authStore";

export default function AgencyOutletGuard() {
  const user = useUser();
  if (!user?.isAgency) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
